import React from 'react'
import styles from './ForwardStyles'
import { Icon } from 'semantic-ui-react'

export default ({ onClick }) => {
  return (
    <div className={styles.component}>
      <Icon
        className={styles.button}
        onClick={onClick}
        title='Jump to next frame'
        name='forward' />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/Components/VideoPlayer/JumpFrame/Forward.js